// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { onGet } from './fakeDB'

export const getData = createAsyncThunk('datatables/getData', async params => {
  const response = onGet(params)
  console.log(response)
  return { allData: response[1].allData, data: response[1].invoices, totalPages: response[1].total, params }
})
console.log(getData)

export const datatablesSlice = createSlice({
  name: 'datatables',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.params = action.payload.params
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
    })
  }
})

export default datatablesSlice.reducer
